module.exports = __webpack_public_path__ + "img/teams-football.b464e890.jpg";